import { createAsyncComponent } from '@mts-fe/utils';
import { PCMode } from '@mts/utils/env';
import BasicForm from './src/BasicForm.vue';
import SimpleForm from './src/SimpleForm.vue';

export { /** @deprecated */ default as ApiButtonGroup } from './src/components/ApiButtonGroup.vue';
// export { default as ApiCascader } from './src/components/ApiCascader.vue';
export { default as ApiRadioGroup } from './src/components/ApiRadioGroup.vue';
export { default as ApiSegmented } from './src/components/ApiSegmented.vue';
export { default as ApiSelect } from './src/components/ApiSelect.vue';
// export { default as ApiSelectAdd } from './src/components/ApiSelectAdd.vue';
// export { default as ApiTransfer } from './src/components/ApiTransfer.vue';
// export { default as ApiTree } from './src/components/ApiTree.vue';
export { default as ApiTreeSelect } from './src/components/ApiTreeSelect.vue';
export { default as IconPicker } from './src/components/IconPicker.vue';
export { /** @deprecated */ default as InputCode } from './src/components/InputCode.vue';
export { default as ModalTableSelect } from './src/components/ModalTableSelect.vue';
// export { default as RadioButtonGroup } from './src/components/RadioButtonGroup.vue';
export { default as ReadonlyText } from './src/components/ReadonlyText.vue';
export { default as Stepper } from './src/components/Stepper.vue';
export { /** @deprecated */ default as VirtualInput } from './src/components/VirtualInput.vue';
export { useCountMap } from './src/hooks/useCountMap';
export { useForm } from './src/hooks/useForm';
export * from './src/types/form';
export * from './src/types/formItem';

const AutoForm = PCMode ? BasicForm : SimpleForm;
export { AutoForm, BasicForm, SimpleForm };

export const QuickRangePicker = createAsyncComponent(
  () => import('@mts/components/Form/src/components/QuickRangePicker.vue'),
);

export const SimpleSearch = createAsyncComponent(
  () => import('@mts/components/Form/src/SimpleSearch.vue'),
);

export const PopoverSearch = createAsyncComponent(
  () => import('@mts/components/Form/src/PopoverSearch.vue'),
);
